module.exports = __webpack_public_path__ + "img/christ.5502c8ef.png";